// extracted by mini-css-extract-plugin
export var container = "index-module--container--vBOwl";
export var fadein = "index-module--fadein--DykEa";
export var reviewBody = "index-module--reviewBody--EzkPj";
export var reviewImage = "index-module--reviewImage--5p9J3";
export var reviewName = "index-module--reviewName--yhL1p";
export var reviewWrapper = "index-module--reviewWrapper--+lCcf";
export var wrapper = "index-module--wrapper--1V3y1";